import React from 'react';
import SEO from '../components/molecules/SEO';
import Map from '../components/atoms/Map';
import TwoColumn from '../components/molecules/TwoColumn';
import Column from '../components/molecules/Column';
import styled from 'styled-components';
import ContactFormHolder from '../components/molecules/ContactFormHolder';
import { graphql } from 'gatsby';
import MarkdownConverter from '../components/atoms/MarkdownConverter';

const HeroColumn = styled.div`
  padding: 2rem 0;
  > :first-child { margin-top: 0; }
  > :last-child { margin-bottom: 0; }
  h2, h3 {
    ${props => props.theme.fluidType( 0 )};
  }
`;


const Contact = ({data}) => (
  <>
    <SEO title="Contact"/>


    <TwoColumn>
      <Column width="1/5">
        <HeroColumn>
          <h1>Contact The Marion</h1>
          <MarkdownConverter content={data.contentfulGlobalSettings.contactDetails.contactDetails}/>
        </HeroColumn>
      </Column>
      <Column width="5/13">
        <HeroColumn>
          <Map
            googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${process.env.GATSBY_GOOGLE_API_KEY}`}
            loadingElement={<div style={{ height: `100%` }}/>}
            containerElement={<div style={{ height: `40rem` }}/>}
            mapElement={<div style={{ height: `100%` }}/>}
          />
        </HeroColumn>
      </Column>
    </TwoColumn>
    <ContactFormHolder/>
  </>
);

export default Contact;

export const contactPageQuery = graphql`
    query {
        contentfulGlobalSettings {
            contactDetails {
                contactDetails
            }
        }
    }
`;

